"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
var _class, _descriptor;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PaymentMigrationStore = (_class = /*#__PURE__*/function (_RootStore) {
  function PaymentMigrationStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, PaymentMigrationStore);
    _this = _callSuper(this, PaymentMigrationStore);
    (0, _initializerDefineProperty2["default"])(_this, "dashboardStats", _descriptor, _this);
    _this.config = {
      model: _models.PaymentMigration,
      deserialize: true,
      GET: {
        index: '/payment_migrations',
        show: '/payment_migration',
        dashboardStats: '/payment_migration_stats'
      },
      POST: {
        createPaymentSetupSession: '/payment_migrations/create_payment_setup_session'
      },
      PUT: {
        update: '/payment_migrations/:paymentMigrationId',
        syncWithStripe: '/payment_migrations/:paymentMigrationId/sync_with_stripe',
        confirmCancellation: '/payment_migrations/:paymentMigrationId/confirm_cancellation'
      },
      DELETE: {
        destroy: '/payment_migrations/:paymentMigrationId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(PaymentMigrationStore, _RootStore);
  return (0, _createClass2["default"])(PaymentMigrationStore, [{
    key: "getDashboardStats",
    value: function getDashboardStats(callback) {
      var _this2 = this;
      return this.api({}, function (resp) {
        _this2.dashboardStats = resp;
        if (callback) callback(resp);
      }, 'GET', 'dashboardStats');
    }
  }, {
    key: "createPaymentSetupSession",
    value: function createPaymentSetupSession(callback) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.api(params, callback, 'POST', 'createPaymentSetupSession');
    }
  }, {
    key: "syncWithStripe",
    value: function syncWithStripe(params, callback) {
      this.api(params, callback, 'PUT', 'syncWithStripe');
    }
  }, {
    key: "updateMembershipPromise",
    value: function () {
      var _updateMembershipPromise = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(data) {
        var _this$showData;
        var paymentMigrationId, resp;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              paymentMigrationId = (_this$showData = this.showData) === null || _this$showData === void 0 ? void 0 : _this$showData.id;
              if (paymentMigrationId) {
                _context.next = 2;
                break;
              }
              _context.next = 1;
              return this.getShowPromise();
            case 1:
              paymentMigrationId = this.showData.id;
            case 2:
              _context.next = 3;
              return this.updatePromise({
                ids: {
                  paymentMigrationId: paymentMigrationId
                },
                data: data
              });
            case 3:
              resp = _context.sent;
              this.setShowData(resp.paymentMigration);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function updateMembershipPromise(_x) {
        return _updateMembershipPromise.apply(this, arguments);
      }
      return updateMembershipPromise;
    }()
  }, {
    key: "confirmCancellationPromise",
    value: function () {
      var _confirmCancellationPromise = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this$showData2;
        var paymentMigrationId, resp;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              paymentMigrationId = (_this$showData2 = this.showData) === null || _this$showData2 === void 0 ? void 0 : _this$showData2.id;
              if (paymentMigrationId) {
                _context2.next = 2;
                break;
              }
              _context2.next = 1;
              return this.getShowPromise();
            case 1:
              paymentMigrationId = this.showData.id;
            case 2:
              _context2.next = 3;
              return this.apiPromise({
                ids: {
                  paymentMigrationId: paymentMigrationId
                }
              }, 'PUT', 'confirmCancellation');
            case 3:
              resp = _context2.sent;
              this.setShowData(resp);
              return _context2.abrupt("return", resp);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function confirmCancellationPromise() {
        return _confirmCancellationPromise.apply(this, arguments);
      }
      return confirmCancellationPromise;
    }()
  }]);
}(_root_store["default"]), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "dashboardStats", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _class);
var _default = exports["default"] = new PaymentMigrationStore();